

export default {
  cookies: {
    accountname: 'accountname',
    accounttel: 'accounttel',
  },

  T_ValetReservation: function() {
    let _this = this;
    _this.ValetReservationIDX = -1;
    _this.IsExist = false;
    _this.DateTime_Created = '';
    _this.DateTime_Modified = '';
    _this.CarNumber = '';
    _this.CarModel = '';

    _this.DateTime_Reservation = '';
    _this.DateTime_Reservation_Month = '';
    _this.DateTime_Reservation_Date = '';
    _this.DateTime_Reservation_AMPM = '';
    _this.DateTime_Reservation_Hour = '';
    _this.DateTime_Reservation_Minute = '';

    _this.CarOwnerName = '';
    _this.CarOwnerTel = '';
    _this.ReservationRequesterCompany = '';
    _this.ReservationRequesterID = '';
    _this.ReservationRequesterName = '';
    _this.ReservationRequesterTel = '';
  },
  // T_PeriodicCar: function() {
  //   let _this = this;
  //   _this.PeriodicCarIDX = -1;
  //   _this.ParkingLotIDX = -1;
  //   _this.CarNumber = '';
  //   _this.Name = '';
  //   _this.Tel = '';
  //   _this.Model = '';
  //   _this.Description = '';
  //   _this.Charge = '';
  // },
  // T_PeriodicCar_Payment: function () {
  //   let _this = this;
  //   _this.PeriodicCarPaymentIDX = -1;
  //   _this.PeriodicCarIDX = -1;
  //   _this.PaymentYear = -1;
  //   _this.PaymentMonth = -1;
  //   _this.PaymentYearMonth = -1;
  //
  //   _this.PaymentAmount = 0;
  //   _this.PaymentAccountID = '';
  //   _this.PaymentAccountName = '';
  //   _this.PaymentDescription = '';
  //   _this.DateTime_Payment = '';
  //
  //   _this.RefundAmount = 0;
  //   _this.RefundAccountID = '';
  //   _this.RefundAccountName = '';
  //   _this.RefundDescription = '';
  //
  //   _this.IsPeriodicCarDeleted = false;
  // },
  // T_PeriodicCar_TaskHistory: function() {
  //   let _this = this;
  //   _this.PeriodicCarIDX = -1;
  //   _this.CarNumber = '';
  //   _this.Name = '';
  //   _this.Tel = '';
  //   _this.Model = '';
  //   _this.Description = '';
  //   _this.Charge = '';
  // },
}
